// 把后端的区域码（如 es-ES）映射到 i18next 的语言键
export default function normalizeLocale(lng) {
  const map = {
    'en-US': 'en', 'en-GB': 'en',
    'es-ES': 'es', 'es': 'es',
    'fr-FR': 'fr', 'de-DE': 'de',
    'it-IT': 'it', 'pt-PT': 'pt',
    'zh-CN': 'zh', 'zh-TW': 'zh-TW',
    'ca-ES': 'ca',
  };
  if (!lng) return 'en';
  return map[lng] || map[lng.toString()] || (lng.split?.('-')[0] || 'en');
}
